import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant24() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      title1: 'Мы создаем сайты',
      title2: 'бесплатно.',
      sub: `Вы платите только за результат. Если макет нравится — оформляем подписку ${price}/мес за хостинг и поддержку. Если нет — расходимся без обид и оплат.`,
      cta: 'Хочу посмотреть макет'
    },
    ua: {
      title1: 'Ми створюємо сайти',
      title2: 'безкоштовно.',
      sub: `Ви платите лише за результат. Якщо макет подобається — оформлюємо підписку ${price}/міс за хостинг та підтримку. Якщо ні — розходимося без образ і оплат.`,
      cta: 'Хочу подивитися макет'
    },
    en: {
      title1: 'We build websites',
      title2: 'for free.',
      sub: `You only pay for the result. If you like the mockup, you subscribe for ${price}/mo for hosting and support. If not, we part ways with no fees.`,
      cta: 'I want to see a mockup'
    }
  }[language] || content.ru;
  return <>
      <section className="relative min-h-screen w-full overflow-hidden pt-32 pb-20 flex items-center" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-529">
        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col lg:flex-row items-center justify-between gap-12 px-4" data-id="element-530">
          {/* Left Column - Bold Guarantee */}
          <div className="w-full lg:w-1/2 text-left flex flex-col items-start border-l-4 pl-6 md:pl-10" style={{
          borderColor: 'var(--accent)'
        }} data-id="element-531">
            <motion.h1 initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} className="mb-6 text-4xl md:text-5xl lg:text-[4rem] font-black leading-none tracking-tight text-gray-900" data-id="element-532">
              {content.title1} <br data-id="element-533" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600" data-id="element-534">
                {content.title2}
              </span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.1
          }} className="text-lg md:text-xl mb-10 text-gray-600 font-medium max-w-lg leading-relaxed" data-id="element-535">
              {content.sub}
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2
          }} data-id="element-536">
              <button onClick={() => setIsPopupOpen(true)} className="group flex items-center justify-center gap-3 rounded-full px-8 py-4 font-bold text-lg transition-all hover:scale-105 border-2 hover:bg-gray-50" style={{
              borderColor: 'var(--text-primary)',
              color: 'var(--text-primary)'
            }} data-id="element-537">
                {content.cta}
                <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-538" />
              </button>
            </motion.div>
          </div>

          {/* Right Column - Clean Video */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative mt-12 lg:mt-0" data-id="element-539">
            <div className="relative w-full max-w-2xl mx-auto rounded-2xl overflow-hidden shadow-lg border border-gray-100" data-id="element-540">
              <video src="https://cdn.magicpatterns.com/uploads/vrXe21wkVqS62d5BzpZ9eJ/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-541" />
            </div>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-542" />
    </>;
}